import styles from "./index.module.scss";
import classNames from "classnames";
import Logo from "@/components/Logo";
import MenuBar from "./components/menuBar";
import UserInfo from "./components/userInfo";
import ChangeLang from "./components/changeLang";

const Header = () => {
  return (
    <header className={styles.header}>
      <div
        className={classNames(
          "flex_box",
          "flex_between",
          "align_center",
          styles.middleBox
        )}
      >
        <Logo height={52} size={28} type="home" />
        <MenuBar />
        <div className={classNames("flex_box","align_center",styles.left_wrap)}>
          <ChangeLang />
          <UserInfo />
        </div>
      </div>
    </header>
  );
};

export default Header;
